import { actionCreatorFactory } from 'typescript-fsa';
import { ExerciseSchedule } from './types';

const createAction = actionCreatorFactory('ASSET/EXERCISE_SCHEDULE');
const fetchExerciseSchedule = createAction.async<void, ExerciseSchedule, Error>('FETCH');

export { fetchExerciseSchedule };
